import React from 'react';
import { Button, Card, CardBody, Input, Row, Col } from 'reactstrap';
import { ModalAppCode } from '../../../components/appCodes/ModalAppCode';
import { useAppCodes } from '../../../hooks/analytes/useAppCodes';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

export const IndexAppCodes = () => {

    const {
        validacionAnalyte, appCodes, brands, machineModels, infoAnalytes, methods,
        validaciones,
        id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids,
        modal, modalTitle, toggle, method,
        handleInputChange, handleValueSelect, handleMethods, loading, metodosSelect,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        loadingAppCodes,
        exportExcel, handleSearch,handleDelete,saveDelete
    } = useAppCodes();
        console.log("🚀 ~ IndexAppCodes ~ appCodes:", appCodes)

    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "12px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "12px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };

    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button 
                    color="primary" 
                    size="sm"
                    onClick={() => handleUpdate(rowData.id_app_code)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                    
                >
                    <i className="fa fa-edit"></i>
                </Button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_app_code)}
                    disabled={loading}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    const header = (
        <div className="d-flex align-items-center justify-content-between w-100" style={{ gap: '1rem', marginBottom: '1rem' }}>
            <Button
                color="success"
                onClick={exportExcel}
                size="sm"
                title="Exportar a Excel"
                style={{ 
                    padding: "2px 6px", 
                    height: "28px", 
                    fontSize: "0.8rem", 
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <i className="pi pi-file-excel me-1" />
            </Button>

            <Input
                placeholder='Busqueda...'
                className='form-control form-control-sm'
                onChange={handleSearch}
                style={{ maxWidth: '450px', width: '100%' }}
            />
        </div>
    );

    

    return ( 
        <>
            <Card>
                <CardBody className="p-1">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        
                        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                            <div className="ribbon ribbon-clip ribbon-primary" style={{ marginBottom: '1rem' }}>
                                Analitos vinculados
                            </div>
                        </div>
                        <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={handleCreate}>
                            <span className="fa fa-plus-circle"></span>
                        </Button>
                        
                    </div>
                    
                    <Row className={loadingAppCodes ? '' : 'd-none'}>
						<Col sm="12" md="12" lg="12" xl="12" className='text-center'>
                            <div className="loader-box primary" style={{ width: "150px", height: "150px", marginLeft: "45%", marginRight: "50%" }}>
                                <div className="loader-9" color='primary' style={{ height: "150px", width: "150px" }}></div>
                            </div>
							<br />
							<p><b>Cargando analitos vinculados...</b></p>
                        </Col>						
					</Row>
                    <div  className={loadingAppCodes ? 'd-none' : 'table-responsive'}>
                
                        <DataTable
                            value={appCodes}
                            paginator 
                            rows={10} 
                            className="data-table p-datatable-striped p-datatable-sm"
                            emptyMessage={
                                <div className="text-center">
                                    <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "40%" }} alt="Sin Cotizaciones" />
                                    <br />
                                    <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                        Sin Métodos.
                                    </p>
                                </div>
                            }
                            rowsPerPageOptions={[10, 50, 100]}
                            responsiveLayout="scroll"
                            header={header}
                        >
                            <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                            <Column field="brand_name" header="Marca" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column field="machine_model_name" header="Modelo" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column field="info_analyte_name" header="Analito" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column field="code" header="App Código" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column field="convertion_factor" header="F. de conversión" sortable headerStyle={headerStyle} style={cellStyle}/>
                            <Column
                                header="Métodos disponibles"
                                body={(rowData) => (
                                    Array.isArray(rowData.name_methods) && rowData.name_methods.length > 0 ? (
                                        <div style={{ textAlign: "left" }}>
                                            {rowData.name_methods.map((method, index) => (
                                                <div key={index} style={{ fontSize: "12px", marginBottom: "2px" }}>
                                                    • {method[1]}
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <span>Sin métodos asignados</span>
                                    )
                                )}
                                headerStyle={headerStyle}
                                style={cellStyle}
                            />




                            <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />
                        </DataTable>
                    </div>
                </CardBody>
            </Card>
            <ModalAppCode
                {...{
                    modal, modalTitle, toggle, method,
                    validaciones,
                    brands, machineModels, infoAnalytes, methods,
                    id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids,
                    handleInputChange, handleValueSelect, handleMethods, loading, metodosSelect,
                    saveCreate, saveUpdate,
                    validacionAnalyte, saveDelete
                }}
            />
        </>
    );
};
